<template>
  <div class="TemuInventoryMgmt">
    <div class="header-box">
      <div class="header-line">
        <span class="header-label">产品类型</span>
        <el-select placeholder="产品类型" size="small" v-model="params.productType" filterable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
        </el-select>
        <span class="header-label">产品颜色</span>
        <el-select placeholder="产品类型" size="small" v-model="params.productColor" filterable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
        </el-select>
        <span class="header-label">机型</span>
        <el-select placeholder="机型" size="small" v-model="productModel">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
        </el-select>
        <span class="header-label">采购状态</span>
        <el-select placeholder="采购状态" size="small" v-model="params.purchaseStatus">
          <el-option label="全部" value=""></el-option>
          <el-option :value="1" label="需要采购"></el-option>
          <el-option :value="0" label="无需采购"></el-option>
        </el-select>
        <span class="header-label">库存状态</span>
        <el-select placeholder="库存状态" size="small" v-model="params.localStockStatus">
          <el-option label="全部" value=""></el-option>
          <el-option :value="1" label="有库存"></el-option>
          <el-option :value="0" label="无库存"></el-option>
        </el-select>
        <span class="header-label">SKU</span>
        <el-input placeholder="请输入SKU" size="small" clearable v-model="params.sellerSku"> </el-input>
        <span class="header-label">排序类型</span>
        <el-select placeholder="请选择" size="small" v-model="params.sortKey">
          <el-option label="今日天销量" value="todayOrderCount"></el-option>
          <el-option label="最近7天销量" value="last7DayOrderCount"></el-option>
          <el-option label="最近30天销量" value="last30DayOrderCount"></el-option>
          <el-option label="本地库存" value="localInventory"></el-option>
          <el-option label="应采购" value="planPurchase"></el-option>
          <el-option label="采购中" value="inPurchase"></el-option>
          <el-option label="可以库存天数" value="avalibaleDay"></el-option>
          <el-option label="可用库存" value="avalibaleInventory"></el-option>
        </el-select>
        <span class="header-label">增速排序</span>
        <el-select placeholder="请选择" size="small" v-model="params.sortType">
          <el-option label="升序" :value="1"></el-option>
          <el-option label="降序" :value="-1"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="getData">查询</el-button>
      </div>
    </div>
    <el-table ref="table" :data="tableData" border size="small" :height="screenHeight" show-summary>
      <el-table-column label="序号" width="50px" align="right">
        <template slot-scope="scope">
          {{ beginIndex + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="productName" label="产品名称" width="120px"> </el-table-column>
      <el-table-column prop="productColorName" label="颜色" width="80px" sortable> </el-table-column>
      <el-table-column prop="model" label="机型" width="80px" sortable> </el-table-column>
      <el-table-column prop="skc" label="SKC" width="100px" sortable> </el-table-column>
      <el-table-column prop="spu" label="SPU" width="100px" sortable> </el-table-column>
      <el-table-column prop="skuId" label="SKU ID" width="100px" sortable> </el-table-column>
      <el-table-column prop="skuNum" label="SKU货号" width="200px" sortable> </el-table-column>
      <el-table-column prop="sellerSku" label="SKU" width="250px" sortable>
        <template slot-scope="scope">
          <span @click="copySku(scope.row.sellerSku)">{{ scope.row.sellerSku }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="localInventory" label="本地库存" width="80px" align="right" sortable> </el-table-column>
      <el-table-column prop="planPurchase" label="应采购" width="80px" align="right" sortable> </el-table-column>
      <el-table-column prop="inPurchase" label="采购中" width="80px" align="right" sortable> </el-table-column>
      <el-table-column prop="avalibaleDay" label="可以库存天数" width="80px" align="right" sortable>
        <template v-slot="scope">
          <div :class="getInventoryDayStyleClass(scope.row)">{{ scope.row.avalibaleDay }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="avalibaleInventory" label="可用库存" width="80px" align="right" sortable>
        <template v-slot="scope">
          <div :class="getInventoryStyleClass(scope.row)">{{ scope.row.avalibaleInventory }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="todayOrderCount" label="今日天销量" width="80px" align="right" sortable> </el-table-column>
      <el-table-column prop="last7DayOrderCount" label="最近7天销量" width="80px" align="right" sortable> </el-table-column>
      <el-table-column prop="last30DayOrderCount" label="最近30天销量" width="80px" align="right" sortable> </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <!-- <el-button type="text" size="small" @click="editProduct(scope.row)">编辑</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick"> </el-pagination>

    <el-dialog title="批量修改价格" :visible.sync="parentProductDialogVisible" :close-on-click-modal="false" width="1000px">
      <div class="form-line">
        <span class="form-label"><span>*</span>型号</span>
        <el-select placeholder="机型" size="small" v-model="batchParams.modelType">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>颜色</span>
        <el-select placeholder="产品类型" size="small" v-model="batchParams.colorType">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>售价</span>
        <el-input class="form-input" placeholder="请输入" v-model="batchParams.price" size="small" clearable> </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="parentProductDialogVisible = false">取 消</el-button>
        <!-- <el-button type="primary" @click="handleConfirmBtn">确 定</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { activeProducts, colors, models, iPhoneModels, products, getPhoneCaseContantInfo } from "../../utils/constant.js";
export default {
  data() {
    return {
      configMaterialDialogVisible: false,
      screenHeight: document.body.clientHeight - 64 - 54 - 68 - 20,
      beginIndex: 0,
      productType: this.$route.query.productType,
      productList: [],
      colorList: colors,
      modelList: models,
      productModel: "",
      batchParams: {
        modelType: "",
        colorType: "",
      },
      colors: colors,
      models: [],
      iPhoneModels: iPhoneModels,
      productLists: products,
      checkedModels: [],
      checkedColors: [],
      parentProductDialogVisible: false,
      stockCycleDialogVisible: false,
      colorDialogVisible: false,
      products: [],
      exportProducts: [],
      multipleSelection: [],
      colorInfo: {
        name: "",
        key: "",
      },
      materialConfig: [],
      materials: [],
      tableData: [],
      params: {
        productType: "",
        productColor: "",
        productModel: "",
        beginIndex: 0,
        pageSize: 200,
        sellerSku: "",
        purchaseStatus: "",
        localStockStatus: "",
        sortKey: "",
        sortType: 1,
      },
      total: 0,
      pageCount: 1,
    };
  },
  watch: {
    productModel: {
      handler: function (newValue, oldValue) {
        let blankReg = new RegExp(" ", "igm");
        let productModel = newValue.replace(blankReg, "");
        this.params.productModel = productModel;
      },
    },
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },

  mounted() {
    this.getData();
    this.getAllParentProducts();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 54 - 68;
    },
    getAllParentProducts() {
      requestModules
        .fetchAllParentProducts({ status: 1 })
        .then(res => {
          this.productList = res.ldata;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        });
    },
    getData() {
      requestModules
        .fetchTemuInventorys(this.params)
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "获取列表失败",
            });
            return;
          }

          this.tableData = res.ldata;
          this.total = res.total;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        });
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getData();
    },
    getInventoryDayStyleClass(row) {
      let inventoryDay = row.avalibaleDay;
      let avalibaleInventory = row.avalibaleInventory;
      let last30DayOrderCount = row.last30DayOrderCount;
      if (avalibaleInventory == 0 && last30DayOrderCount == 0) {
        return "";
      }

      let styleClass = "";
      inventoryDay <= 3 && (styleClass = "redBg");
      inventoryDay > 3 && inventoryDay <= 5 && (styleClass = "yellowBg");
      inventoryDay > 5 && inventoryDay <= 14 && (styleClass = "greenBg");
      inventoryDay > 14 && (styleClass = "redText");
      return styleClass;
    },
    getInventoryStyleClass(row) {
      let inventory = row.avalibaleInventory;
      let last30DayOrderCount = row.last30DayOrderCount;
      if (inventory == 0 && last30DayOrderCount == 0) {
        return "";
      }

      let styleClass = "";
      inventory <= 3 && (styleClass = "redBg");
      inventory > 3 && inventory <= 5 && (styleClass = "yellowBg");
      inventory > 5 && inventory <= 14 && (styleClass = "greenBg");
      return styleClass;
    },
    copySku(sku) {
      navigator.clipboard
        .writeText(sku)
        .then(() => {
          this.$message.success("已复制SKU");
        })
        .catch(error => {
          this.$message.error("复制SKU失败");
        });
    },
  },
};
</script>

<style lang="scss">
.TemuInventoryMgmt {
  padding-left: 20px;
  background-color: white;
  .redText {
    color: red;
  }
  .redBg {
    background-color: red;
    color: white;
  }
  .yellowBg {
    background-color: yellow;
  }
  .greenBg {
    background-color: green;
    color: white;
  }
  .redText {
    color: red;
  }
  .greenText {
    color: red;
  }
  .greenYellowText {
    color: rgb(233, 104, 104);
  }
  .yellowText {
    color: rgb(112, 56, 56);
  }
  .no-padding {
    padding: 0px !important;
    .cell {
      padding: 0px !important;
    }
  }
  .form-line {
    height: 40px;
    line-height: 40px;

    .form-label {
      margin: 5px 10px 5px 0px;
      width: 110px;
      text-align: right;
      display: inline-block;
      span {
        color: red;
      }
    }
    .form-input {
      width: 800px;
      margin: 5px 0px;
      vertical-align: top;
    }
    .form-group {
      width: 750px;
      margin: 5px 0px;
      display: inline-block;
      vertical-align: top;

      .el-checkbox {
        width: 70px;
      }
    }
  }
}
.form-line {
  .form-label {
    margin: 5px 10px 5px 0px;
    width: 80px;
    text-align: right;
    display: inline-block;
    span {
      color: red;
    }
  }
  .form-input {
    width: 800px;
    margin: 5px 0px;
    vertical-align: top;
  }
  .form-group {
    width: 750px;
    margin: 5px 0px;
    display: inline-block;
    vertical-align: top;

    .el-checkbox {
      width: 70px;
    }
    .el-radio {
      width: 70px;
    }
  }
}
</style>
